export const urlApi = 'http://www.juancarlosmacias.es/';



